import type { paths } from "../../__definitions__/email-engine-v2.changeengine.com-definitions";
import type { Workers } from "../../utils/service-url";
import type { ApiResponse } from "./client";
import { WorkerApiService } from "./worker";

type EmailEngineV2BuildMessageRequest =
  paths["/build-message"]["post"]["requestBody"]["content"]["application/json"];

export type EmailEngineV2Message =
  paths["/build-message"]["post"]["responses"]["200"]["content"]["application/json"];

export class EmailEngineSevice extends WorkerApiService {
  module = "email-engine-v2" as const satisfies Workers;

  async buildMessage(
    body: EmailEngineV2BuildMessageRequest,
  ): Promise<ApiResponse<EmailEngineV2Message>> {
    return await this.post("build-message", { ...body });
  }

  async updateSuppressionList(): Promise<ApiResponse<{ ok: boolean }>> {
    return await this.post("update-suppression-list", {});
  }
}
